module.exports = __webpack_public_path__ + "static/media/sixarms.f76d923c.avif";